export default "__VITE_ASSET__B9V$ePpS__"